/**
 * FerryXpress – account header label
 *
 * The desktop Warehouse theme renders “Einloggen / Registrieren” as a
 * standalone label while the actual login link is shown underneath.
 * Make the label itself navigate to the normal Shopify login page.
 */
(function () {
  'use strict';

  function bindAccountTitle() {
    var title = document.querySelector(
      '.header__action-item--account .header__action-item-title'
    );
    if (!title || title.dataset.fxAccountLink === 'true') return;

    title.dataset.fxAccountLink = 'true';
    title.setAttribute('role', 'link');
    title.setAttribute('tabindex', '0');
    title.setAttribute('aria-label', 'Einloggen / Registrieren');
    title.style.cursor = 'pointer';

    function openAccount() {
      window.location.assign('/account/login');
    }

    title.addEventListener('click', openAccount);
    title.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openAccount();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAccountTitle);
  } else {
    bindAccountTitle();
  }
})();